import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Index } from '@classes/index';
import { IndexGridViewItem } from '@classes/index-grid-view-item';
import { IndexService } from 'app/core/services/index.service';
import { UiService } from 'app/core/services/ui.service';
import { IndexDetailComponent } from '../index-detail/index-detail.component';

@Component({
  selector: 'app-index-grid',
  templateUrl: './index-grid.component.html',
  styleUrls: ['./index-grid.component.scss']
})
export class IndexGridComponent implements OnInit, AfterViewInit {

  dataSource = new MatTableDataSource<IndexGridViewItem>();
  pageSizeOptions = [25, 50, 100];
  selectedRowID: string;
  displayedColumns: string[] = [
    'year',
    'value',
    'coef',
    // 'modifiedDate',
    // 'userName',
    'action'
  ];

  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) MatPaginatorIndex: MatPaginator;

  constructor(
    public indexService: IndexService,
    public uiService: UiService,
    public dialog: MatDialog
  ) { }

  ngOnInit() {
    this.getIndexs();
  }

  getIndexs() {
    this.uiService.addRouteLoading();

    this.indexService.masterIndex.subscribe(coefMaster => {
      this.indexService.getIndexs().subscribe(indexs => {
        this.dataSource.data = indexs.map(m => new IndexGridViewItem({
          id: m.id,
          value: m.value,
          year: m.year,
          coef: (m.value || 1) / (coefMaster?.value || 1)
        }));
        this.uiService.removeRouteLoading();
      }, error => {
        console.error(error);
        this.uiService.removeRouteLoading();
      });
    });


  }

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.MatPaginatorIndex;
    // this.dataSource.sortingDataAccessor = (data: any, sortHeaderId: string): string => {
    //   if (typeof data[sortHeaderId] === 'string') {
    //     return data[sortHeaderId].toLocaleLowerCase();
    //   }
    
    //   return data[sortHeaderId];
    // };
  }

  selectItemClick(item: IndexGridViewItem) {
    this.selectedRowID = item.id || '';
  }

  editElement(item: IndexGridViewItem) {
    const data = new Index({
      id: item.id || "",
      value: item.value,
      year: item.year
    });
    const dialogRef = this.dialog.open(IndexDetailComponent, {
      data,
      hasBackdrop: true
    });
    dialogRef.afterClosed().subscribe(success => {
      if (success) {
        this.getIndexs();
        this.indexService.getCurrentIndex();
      }
    });
  }
}
